// extracted by mini-css-extract-plugin
export default {"table":"DataTableRemotePaging_table__Y1nAW","pageSize":"DataTableRemotePaging_pageSize__qb8Km","selected":"DataTableRemotePaging_selected__EkV75"};